import React, { FC } from 'react'

import { Txt } from 'src/components/atoms'
import { RangeDateDropdown } from 'src/components/molecules'

type Props = {
  startDate?: Date
  endDate?: Date
  onClickDay: (input: { startDate: Date; endDate?: Date }) => void
  className?: string
}

export const ProjectSearchDuration: FC<Props> = ({ startDate, endDate, onClickDay, className }) => {
  return (
    <div className={className}>
      <Txt sizeType="s" className="tw-text-standardText-secondary">
        期間
      </Txt>
      <RangeDateDropdown
        startDate={startDate}
        endDate={endDate}
        onClickDay={onClickDay}
        className="tw-mt-s-2"
      />
    </div>
  )
}
